export const SUBMITTING = 'pdp.button.submitting';
export const REDIRECTING = 'pdp.button.redicting';
export const PRODUCT_ADD_TO_CART = 'pdp.button.add_to_cart';
